import React, { useState } from 'react';
import moment from 'moment';

import DayPicker from 'react-day-picker';
import 'react-day-picker/lib/style.css';

import { FontAwesomeIcon as FA } from '@fortawesome/react-fontawesome';
import { faFilter } from '@fortawesome/free-solid-svg-icons/faFilter';

const DayRangePicker = ({
  value,
  placeholder = 'Pick a date',
  onChange = () => {},
  className = '',
}) => {
  const [show, setShow] = useState(false);

  return (
    <span className={`position-relative ${className}`}>
      <div className="btn-group bg-white">
        <span className="input-group-text bg-white">
          <FA icon={faFilter} />
        </span>
        <button className="btn border" onClick={() => setShow(!show)}>
          {value
            ? moment(value).format('YYYY.MM.DD')
            : placeholder}
        </button>
        {value && (
          <button
            className="btn border"
            onClick={() => {
              setShow(false);
              onChange(null);
            }}
          >
            &times;
          </button>
        )}
      </div>
      {show && (
        <div
          className={`
            position-absolute bg-white
            border
            mt-2 pt-3 px-3
          `}
          style={{ zIndex: 100, left: 0 }}
        >
          <DayPicker
            className="Selectable"
            initialMonth={
              value || new Date()
            }
            selectedDays={value}
            onDayClick={(date) => {
              const d = moment(date).startOf('d').toDate();

              setShow(false);
              onChange(d);
            }}
          />
        </div>
      )}
    </span>
  );
};

export default DayRangePicker;
